export default __webpack_public_path__ + "static/media/svg-6.eed1c4b3.svg";